import {FulltextSearch} from '@/api/meta/filters';
import {autoImplement} from '@/util';
import Provider, {ApiProvider, ProviderStatus} from './Provider';

export interface ProviderDistanceFilters {
  DistanzKm$To: number;
  KundenNr?: number;
  'Kunde/KundStatus$In'?: ProviderStatus[];
  'Kunde/Kundname'?: string;
  'Kunde/LieferantErledigt'?: boolean;
  'Kunde/Fulltext$Fulltext': FulltextSearch;
}

export interface GeneralProviderDistance {
  KundenNr: number;
  DistanzKm: number;
}

export interface ApiProviderDistance extends GeneralProviderDistance {
  Kunde: ApiProvider;
}

export interface ProviderDistanceInterface extends GeneralProviderDistance {
  Kunde: Provider;
}

export default class ProviderDistance extends autoImplement<ProviderDistanceInterface>() {
  static fromApi(apiProviderDistance: ApiProviderDistance) {
    const {
      Kunde,
      ...data
    } = apiProviderDistance;
    return new ProviderDistance({
      ...data,
      Kunde: Provider.fromApi(Kunde),
    });
  }
}
